export var MaterialParametrs;
(function (MaterialParametrs) {
    MaterialParametrs["Thickness"] = "Thickness";
    MaterialParametrs["Density"] = "Density";
    MaterialParametrs["ConnectionNumber"] = "ConnectionNumber";
    MaterialParametrs["RackStep"] = "RackStep";
    MaterialParametrs["Width"] = "Width";
})(MaterialParametrs || (MaterialParametrs = {}));
export var RuMaterialParametrs;
(function (RuMaterialParametrs) {
    RuMaterialParametrs["Thickness"] = "\u0422\u043E\u043B\u0449\u0438\u043D\u0430";
    RuMaterialParametrs["Density"] = "\u041F\u043B\u043E\u0442\u043D\u043E\u0441\u0442\u044C";
    RuMaterialParametrs["ConnectionNumber"] = "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0439";
    RuMaterialParametrs["RackStep"] = "\u0428\u0430\u0433 \u0441\u0442\u043E\u0435\u043A";
    RuMaterialParametrs["Width"] = "\u0428\u0438\u0440\u0438\u043D\u0430";
})(RuMaterialParametrs || (RuMaterialParametrs = {}));
